var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"frame",staticClass:"responsive-certificate-frame",style:(_vm.frameStyle)},[_c('div',{staticClass:"responsive-certificate-frame__canvas",style:(_vm.canvasStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }